import {type ReactElement, ReactNode, createElement} from 'react'

type ContextProvider = ({children}: {children: ReactNode}) => ReactElement
type Props = {contextProviders: ContextProvider[]; children: ReactElement}

export const CombinedContextProvider = ({contextProviders, children}: Props): ReactElement => {
  return contextProviders.reduceRight(
    (acc, contextProvider) => createElement(contextProvider, undefined, acc),
    children
  )
}
